module.exports = __webpack_public_path__ + "img/krystal-resort.8ef50f2e.jpg";